import React, { useEffect, useState } from 'react';
import { SectionWrapper } from '../../../components/SectionWrapper';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import {
	CHECKOUT_FORM_FIELDS, CHECKOUT_FORM_FIELDS_NAMES, CheckoutFieldsReturnTypes,
	CheckoutFieldsTypes, getFormattedCheckoutFormFields,
	initialCheckoutValues
} from '../../../constants/merchant/checkout-form';
import { ChangeColorInput } from '../../../components/developers/widget-configuration/ChangeColorInput';
import { UploadLogo } from '../../../components/developers/widget-configuration/UploadLogo';
import { Area } from 'react-easy-crop';
import { ImageCropper } from '../../../components/common/ImageCropper';
import { ModalWindow } from '../../../components/modal/ModalWindow';
import { getCroppedImg } from '../../../utils/imageCrop';
import { Input } from '../../../components/developers/page-components/Input';
import { ButtonComponent } from '../../../components/ButtonComponent';
import { fetchCheckoutConfigurationData, setCheckoutConfigurations } from '../../../store/merchnts/actions/widget';
import { useParams } from 'react-router-dom';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { FaviconLoader } from '../../../components/merchants/sites/FaviconLoader';
import { Spinner } from '../../../components/Spinner';

export const MerchantCheckoutConfigurationPage = (): React.ReactElement => {
	const { t } = useTranslation();
	const { merchantState: { isCheckoutConfigurationLoading }, dispatch } = useMerchants();

	const { id, siteId } = useParams<{ id: string, siteId: string }>();
	const [selectedFile, setSelectedFile] = useState(undefined);
	const [selectedFileBg, setSelectedBgFile] = useState(undefined);
	const [preview, setPreview] = useState<string | undefined>();
	const [previewBg, setPreviewBg] = useState<string | undefined>();
	const [pixelCrop, setPixelCrop] = useState<Area | undefined>();
	const [uploadedFile, setUploadedFile] = useState<string | undefined>();
	const [uploadedBGImage, setUploadedBGImage] = useState<string | undefined>();
	const [uploadedFavicon, setUploadedFavicon] = useState<string | undefined>();
	const [isDisable, setIsDisable] = useState<boolean>(false);
	const [isDisableBg, setIsDisableBg] = useState<boolean>(false);
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
	const [isBgModalOpen, setIsBgModalOpen] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);

	const formik = useFormik<CheckoutFieldsTypes>({
		initialValues: initialCheckoutValues,
		onSubmit: () => formSubmit()
	});

	const formSubmit = async (): Promise<void> => {
		if (!formik.isValid) {
			return;
		}
		setLoading(true);

		const data: CheckoutFieldsReturnTypes = getFormattedCheckoutFormFields(formik.values);

		if (formik.values[CHECKOUT_FORM_FIELDS.BACKGROUND_IMAGE]) {
			const imageArray = formik.values[CHECKOUT_FORM_FIELDS.BACKGROUND_IMAGE].split(':');
			if (formik.values[CHECKOUT_FORM_FIELDS.BACKGROUND_IMAGE] && imageArray[0] !== 'https') {
				data.checkoutPageBackgroundImage = formik.values.checkoutPageBackgroundImage;
			} else {
				data.checkoutPageBackgroundImage = null;
			}
		}

		if (formik.values[CHECKOUT_FORM_FIELDS.LOGO]) {
			const imageArray = formik.values[CHECKOUT_FORM_FIELDS.LOGO].split(':');
			if (formik.values[CHECKOUT_FORM_FIELDS.LOGO] && imageArray[0] !== 'https') {
				data.logoFile = formik.values.logoFile;
			} else {
				data.logoFile = null;
			}
		}

		if (formik.values[CHECKOUT_FORM_FIELDS.FAVICON]) {
			const imageArray = formik.values[CHECKOUT_FORM_FIELDS.FAVICON].split(':');
			if (formik.values[CHECKOUT_FORM_FIELDS.FAVICON] && imageArray[0] !== 'https') {
				data.favicon = formik.values.favicon;
			} else {
				data.favicon = null;
			}
		}

		await setCheckoutConfigurations(data?.id, data, formik);
		setLoading(false);
	};

	useEffect(() => {
		if (!selectedFile) {
			setPreview(undefined);
			return;
		}

		const objectUrl = URL.createObjectURL(selectedFile);
		// @ts-ignore
		setPreview(objectUrl);

		return (): void => URL.revokeObjectURL(objectUrl);
	}, [selectedFile]);

	useEffect(() => {
		if (!selectedFileBg) {
			setPreviewBg(undefined);
			return;
		}

		const objectUrl = URL.createObjectURL(selectedFileBg);
		// @ts-ignore
		setPreviewBg(objectUrl);

		return (): void => URL.revokeObjectURL(objectUrl);
	}, [selectedFileBg]);

	useEffect(() => {
		void fetchCheckoutConfigurationData(dispatch, id, siteId, formik, setUploadedFile, setUploadedBGImage, setUploadedFavicon);
	}, []);

	// const selectImage = (e, fieldName): void => {
	const selectImage = (e): void => {
		// if (!e.target.files || e.target.files.length === 0) {
		// 	return;
		// }
		// const files = e.target.files;
		// console.log('files', files[0].size);
		// if (files[0].size > 100000) {
		// 	toaster.push(toastMessage({
		// 		text: 'Image is to big!',
		// 		type: 'error'
		// 	}), { placement: 'topEnd' });
		// 	return;
		// }
		// const reader = new FileReader();
		// reader.readAsDataURL(files[0]);
		//
		// reader.onload = function (): void {
		// 	formik.setFieldValue(fieldName, reader.result);
		// 	setUploadedBGImage('image');
		// };
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedBgFile(undefined);
			return;
		}
		const files = e.target.files;
		const reader = new FileReader();
		reader.readAsDataURL(files[0]);

		reader.onload = function (): void {
		};

		setIsBgModalOpen(true);
		// formik.setFieldValue(CHECKOUT_FORM_FIELDS.BACKGROUND_IMAGE, files[0]);
		setSelectedBgFile(files[0]);
	};

	const onSelectFile = (e): void => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(undefined);
			return;
		}
		const files = e.target.files;
		const reader = new FileReader();
		reader.readAsDataURL(files[0]);

		reader.onload = function (): void {
		};

		setIsModalOpen(true);
		setSelectedFile(files[0]);
	};

	const onDeleteFile = (): void => {
		formik.setFieldValue(CHECKOUT_FORM_FIELDS.LOGO, '');
		setUploadedFile(undefined);
		setPreview(undefined);
	};

	const onDeleteBgFile = (): void => {
		formik.setFieldValue(CHECKOUT_FORM_FIELDS.BACKGROUND_IMAGE, '');
		setUploadedBGImage(undefined);
		setPreviewBg(undefined);
	};

	const onEditFile = (): void => {
		if (preview) {
			setIsModalOpen(true);
		}
	};

	const onEditBgFile = (): void => {
		if (previewBg) {
			setIsBgModalOpen(true);
		}
	};

	const modalClose = (): void => {
		setIsModalOpen(false);
	};

	const onModalSave = async (): Promise<void> => {
		try {
			const { file, fileURL } = await getCroppedImg({
				imageSrc: preview,
				pixelCrop,
				maxWidth: 2048
			});
			await formik.setFieldValue(CHECKOUT_FORM_FIELDS.LOGO, file);
			setUploadedFile(fileURL);
			setIsDisable(true);
		} catch (e) {
			console.error(e);
		}
		setIsModalOpen(false);
	};

	const onModalBgSave = async (): Promise<void> => {
		try {
			const { file, fileURL } = await getCroppedImg({
				imageSrc: previewBg,
				pixelCrop,
				maxWidth: 2048
			});
			await formik.setFieldValue(CHECKOUT_FORM_FIELDS.BACKGROUND_IMAGE, file);
			setUploadedBGImage(fileURL);
			setIsDisableBg(true);
		} catch (e) {
			console.error(e);
		}
		setIsBgModalOpen(false);
	};

	if (isCheckoutConfigurationLoading) {
		return (
			<div className="card site-loading-height">
				<div className="card-body">
					<Spinner pageLoader/>
				</div>
			</div>
		);
	}

	return (
		<>
			<SectionWrapper
				sectionAdditionalClass="w-xl-50 min-height-400"
				title={t('MERCHANT.CHECKOUT_CONFIGURATION')}
				isCardBody
				left="35%"
			>
				{ loading && <Spinner pageLoader transparentComponentLoader /> }
				<form className="row" onSubmit={formik.handleSubmit}>

					{/*BG Image*/}
					<UploadLogo
						label={t(CHECKOUT_FORM_FIELDS_NAMES.BACKGROUND_IMAGE)}
						fieldName={CHECKOUT_FORM_FIELDS.BACKGROUND_IMAGE}
						formik={formik}
						uploadedFile={uploadedBGImage}
						onEditFile={onEditBgFile}
						onDeleteFile={onDeleteBgFile}
						onSelectFile={selectImage}
						isDisable={isDisableBg}
						imageAdditionalClass="bgc-image-size"
						additionalClass="col-6 col-sm-5"
						isWidgetPage
						isAdmin
					/>

					<div className="d-none d-sm-block col-1"/>

					{/*Logo*/}
					<UploadLogo
						uploadedFile={uploadedFile}
						formik={formik}
						isDisable={isDisable}
						onDeleteFile={onDeleteFile}
						onSelectFile={onSelectFile}
						onEditFile={onEditFile}
						isAdmin
						label={t(CHECKOUT_FORM_FIELDS_NAMES.LOGO)}
						fieldName={CHECKOUT_FORM_FIELDS.LOGO}
						imageAdditionalClass="download-file-logo"
						additionalClass="col-6 col-sm-5"
						isWidgetPage
					/>

					{/*Favicon*/}
					<FaviconLoader
						formik={formik}
						uploadedFavicon={uploadedFavicon}
						setUploadedFavicon={setUploadedFavicon}
					/>

					<div className="d-none d-sm-block col-1"/>

					{/*Primary color*/}
					<div className="col-6">
						{/*Primary Color*/}
						<ChangeColorInput
							formik={formik}
							fieldName={CHECKOUT_FORM_FIELDS.PRIMARY_COLOR}
							fieldLabel={t(CHECKOUT_FORM_FIELDS_NAMES.PRIMARY_COLOR)}
							placeholder={t('COLOR_MODULE.BTN_PLACEHOLDER')}
							additionalClassname="col-12"
							isAdmin
						/>
						{/*Primary Color*/}
						<ChangeColorInput
							formik={formik}
							fieldName={CHECKOUT_FORM_FIELDS.SECONDARY_COLOR}
							fieldLabel={t(CHECKOUT_FORM_FIELDS_NAMES.SECONDARY_COLOR)}
							placeholder={t('COLOR_MODULE.BTN_PLACEHOLDER')}
							additionalClassname="col-12"
							isAdmin
						/>

					</div>

					{/*Checkbox*/}
					<div className="input-container col-6 pt-5 pt-sm-9">
						<Input
							formik={formik}
							inputType="checkbox"
							fieldLabel={t(CHECKOUT_FORM_FIELDS_NAMES.IS_ONE_COLUMN)}
							checkboxFieldName={CHECKOUT_FORM_FIELDS.IS_ONE_COLUMN}
							// TODO remove disable when fix checkout poll
							disabled
						/>
					</div>

					{/*Font Color*/}
					<div className="col-6">
						<ChangeColorInput
							formik={formik}
							fieldName={CHECKOUT_FORM_FIELDS.FONT_COLOR}
							fieldLabel={t(CHECKOUT_FORM_FIELDS_NAMES.FONT_COLOR)}
							placeholder={t('COLOR_MODULE.BTN_PLACEHOLDER')}
							additionalClassname="col-12"
							isAdmin
						/>
					</div>
					<ButtonComponent
						buttonName={t('COLOR_MODULE.SAVE')}
						additionalClass="btn-sm d-block ms-auto w-75px me-3"
						type="submit"
						loading={loading}
					/>
				</form>
			</SectionWrapper>
			<ModalWindow
				isOpen={isModalOpen}
				modalTitle={t('COLOR_MODULE.CROP_TITLE')}
				confirmButtonText={t('COLOR_MODULE.SAVE')}
				onClose={modalClose}
				onCancel={modalClose}
				onConfirm={onModalSave}
				contentClassName="position-relative"
				content={
					<ImageCropper
						image={preview}
						setPixelCrop={setPixelCrop}
						aspect={34 / 10}
					/>
				}
			/>

			<ModalWindow
				isOpen={isBgModalOpen}
				modalTitle={t('COLOR_MODULE.CROP_TITLE')}
				confirmButtonText={t('COLOR_MODULE.SAVE')}
				onClose={(): void => setIsBgModalOpen(false)}
				onCancel={(): void => setIsBgModalOpen(false)}
				onConfirm={onModalBgSave}
				contentClassName="position-relative"
				content={
					<ImageCropper
						image={previewBg}
						setPixelCrop={setPixelCrop}
						aspect={16/9}
					/>
				}
			/>
		</>
	);
};
